import * as yup from 'yup';

export const schema = yup.object({
  name: yup.string().required('Name on card is required'),
  cardNumber: yup.string().required('Card number is required'),
  cardExpiry: yup.string().required('Expiration date is required'),
  cardCvc: yup.string().required('Security code is required'),
});
